// Articole din presă despre Travel Time D&R (surse independente).
// Pentru un articol nou: adăugați un obiect la începutul listei (cele mai noi primele).
// Rezumatul e scris de noi; titlul rămâne cel original al articolului.
const PRESS = [
  {
    publisher: "Termene.ro",
    publisherUrl: "https://termene.ro",
    title:
      "Clasamentul celor mai mari 20 de agenții de turism și tur-operatori. Afacerile au crescut cu 300 de milioane de euro",
    url: "https://termene.ro/articole/topul-agentiilor-de-turism-si-tur-operatorilor",
    date: "2024-09-15",
    author: "Marian Păvălașc",
    summary: {
      en: "Travel Time D&R ranks 9th among Romania's 20 largest travel agencies and tour operators, with a turnover of RON 121.8 million.",
      ro: "Travel Time D&R ocupă locul 9 în topul celor mai mari 20 de agenții de turism și tur-operatori din România, cu o cifră de afaceri de 121,8 milioane de lei.",
    },
  },
  {
    publisher: "Curs de Guvernare",
    publisherUrl: "https://cursdeguvernare.ro",
    title: "Cele mai mari agenții de turism din România. 14 jucători din piață",
    url: "https://cursdeguvernare.ro/cele-mai-mari-agentii-de-turism-din-romania-14-jucatori-din-piata.html",
    date: "2024-06-12",
    author: null,
    summary: {
      en: "Travel Time D&R is 5th among the largest travel agencies in Romania by turnover, with RON 121.8 million and an average of 24 employees.",
      ro: "Travel Time D&R este pe locul 5 între cele mai mari agenții de turism din România după cifra de afaceri, cu 121,8 milioane de lei și o medie de 24 de angajați.",
    },
  },
  {
    publisher: "Ziarul Financiar",
    publisherUrl: "https://www.zf.ro",
    title:
      "Agenţia de turism Travel Time din Bucureşti: Luna iunie a debutat cu solicitări noi şi observăm un trend ascendent, pe măsură ce zborurile se reiau, iar unităţile de cazare îşi deschid porţile",
    url: "https://www.zf.ro/business-travel/agentia-de-turism-travel-time-din-bucuresti-luna-iunie-a-debutat-cu-19417422",
    date: "2020-07-10",
    author: "Alina-Elena Vasiliu",
    summary: {
      en: "Ziarul Financiar profiles Travel Time, a Bucharest travel agency owned by two Romanian entrepreneurs: demand returned in June 2020 as flights resumed, after a 2019 turnover of RON 94.3 million, up 11% year on year.",
      ro: "Ziarul Financiar prezintă Travel Time, agenție de turism din București deținută de doi antreprenori români: cererea a revenit în iunie 2020, odată cu reluarea zborurilor, după o cifră de afaceri de 94,3 milioane de lei în 2019, în creștere cu 11%.",
    },
  },
  {
    publisher: "StartupCafe",
    publisherUrl: "https://startupcafe.ro",
    title:
      "Peste 400 de agenţii de turism și turoperatori şi-au închis porţile, în ultimii doi ani. Topul agenţiilor din România",
    url: "https://startupcafe.ro/agentii-turism-faliment-top-romania-htm-7407",
    date: "2018-07-02",
    author: "Raluca Abrihan",
    summary: {
      en: "Travel Time D&R is among the 10 most profitable companies in Romanian tourism, according to a KeysFin analysis.",
      ro: "Travel Time D&R se numără printre cele mai profitabile 10 firme din turismul românesc, potrivit unei analize KeysFin.",
    },
  },
];

export default PRESS;
